import React from 'react';

/**
 * 卡片标签组件属性接口
 */
export interface CardTagProps {
  /** 标签文本 */
  text: string;
  /** 标签颜色 */
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger' | 'info';
  /** 自定义类名 */
  className?: string;
}

/**
 * 卡片标签组件
 * 提供统一的卡片标签样式，支持不同颜色
 * @param {CardTagProps} props - 组件属性
 * @returns {JSX.Element} 渲染的React组件
 */
const CardTag: React.FC<CardTagProps> = ({ 
  text, 
  color = 'primary',
  className = '' 
}) => {
  // 根据color属性设置标签颜色
  const colorClasses = {
    primary: 'bg-primary bg-opacity-10 text-primary',
    secondary: 'bg-secondary bg-opacity-10 text-secondary',
    success: 'bg-green-500 bg-opacity-10 text-green-500',
    warning: 'bg-yellow-500 bg-opacity-10 text-yellow-500',
    danger: 'bg-red-500 bg-opacity-10 text-red-500',
    info: 'bg-blue-500 bg-opacity-10 text-blue-500'
  };

  return (
    <span 
      className={`inline-block ${colorClasses[color]} text-xs px-3 py-1 rounded-full ${className}`}
    >
      {text}
    </span>
  );
};

export default CardTag;